import {reactionsHttpRepository} from '../../repositories/reactions-http-repository';
import {reactionsMemoryRepository} from '../../repositories/reactions-memory-repository';

export const readUserReactions = articleId => reactionsHttpRepository.getUserReactions(articleId)
  .then(response => reactionsMemoryRepository.setUserReactions(articleId, response.reactions))
  .catch(console.error);
